import { render } from "./Staff.vue?vue&type=template&id=c6c3102a&scoped=true"
import script from "./Staff.vue?vue&type=script&lang=js"
export * from "./Staff.vue?vue&type=script&lang=js"

import "./Staff.vue?vue&type=style&index=0&id=c6c3102a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c6c3102a"]])

export default __exports__